import type { FC } from 'react';

import { Button } from '@zen/DesignSystem';
import Logo from '@zen/Layout/Header/logo.svg?react';

interface Props {
  isDisabled?: boolean;
  isSavingDraft: boolean;
  onDiscard: () => void;
  onSaveDraft: () => void;
}

const WizardMasthead: FC<Props> = (props) => {
  const { isDisabled = false, isSavingDraft, onDiscard, onSaveDraft } = props;

  return (
    <header className="flex h-16 shrink-0 items-center border-b border-grey-lighter" data-component="wizard-masthead">
      <div className="mx-auto flex w-full max-w-6xl items-center justify-between px-6">
        <Logo className="w-32" data-testid="wizard-logo" />
        <div className="flex items-center space-x-4">
          <Button disabled={isDisabled} iconLeft="zicon-close" onClick={onDiscard} variant="destructive">
            Discard booking
          </Button>
          <Button disabled={isDisabled} isLoading={isSavingDraft} onClick={onSaveDraft} variant="secondary">
            Save draft
          </Button>
        </div>
      </div>
    </header>
  );
};

export type { Props as WizardMastheadProps };
export default WizardMasthead;
